
import React from 'react';
import '../cssfiles/panel.css'

import '../cssfiles/filterbox.css'
import { CartState } from '../context/contextmen'
import { Button, Form } from "react-bootstrap";

function filterbox() {
  const {
    productDispatch,
    productState: {sort},
  } = CartState();
 
    
    
  return (
    <div >
      <h1 className='fonti'>Filter</h1>
      <h4 className='fonti'>SORT BY PRICE</h4>
      <div >
      <div className='form-check'>
      <span>
        <Form.Check
          inline
          label="Price-LOW-HIGH"
          name="group1"
          type="radio"
          id={`inline-1`}
          onChange={() =>
            productDispatch({
              type: "SORT_BY_PRICE",
              payload: "lowToHigh",
            })
          }
          checked={sort === "lowToHigh" ? true : false}
        />
      </span>
      <span>
        <Form.Check
          inline
          label="Price-HIGH-LOW"
          name="group1"
          type="radio"
          id={`inline-2`}
          onChange={() =>
            productDispatch({
              type: "SORT_BY_PRICE",
              payload: "highToLow",
            })
          }
          checked={sort === "highToLow" ? true : false}
        />
      </span>
      <Button
        variant="light"
        onClick={() =>
          productDispatch({
            type: "CLEAR_FILTERS",
          })
        }
      >
        Clear Filters
      </Button>
     
        </div>
        
        </div>
    </div>
  );
}

export default filterbox;